import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Card, Button, Form, InputGroup, Pagination } from 'react-bootstrap';
import AdminQuotingRequest from './Modal/AdminQuotingRequest';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Countdown from 'react-countdown';
import { IconSearch, IconX } from '@tabler/icons-react';
import Loader from '../../Loader';

const Quotations = () => {
    const [pagination, setPagination] = useState({
        limit: 10,
        skip: 0,
        pages: [],
        nextPage: false,
        currentPage: 1,
        previousPage: false
    });

    const [searchText, setSearchText] = useState('');

    const [loader, setLoader] = useState(false);
    const [quotationId, setQuotationId] = useState();
    const [quotations, setQuotations] = useState();
    const [searchKey, setSearchKey] = useState({ key: "" });
    const [QuotingRequestShow, setQuotingRequestShow] = useState(false);
    const [baseCurrency, setBaseCurrency] = useState(null);
    const timerRef = useRef(null);

    const token = useSelector((state) => state.token);

    const getQuotation = (currentPage = 1, search = searchKey.key) => {
        setLoader(true);
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_BASE_URL}/quotation?limit=${pagination.limit || 10}&page=${currentPage}&search=${search}`,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(res => {
            setQuotations(res.data.quotations);
            setLoader(false);
            setPagination((preState) => ({
                ...preState,
                currentPage: res.data.currentPage,
                nextPage: res.data.nextPage,
                pages: res.data.pages,
                previousPage: res.data.previousPage,
            }));
        }).catch(() => {
            setLoader(false);
        });
    }

    const Status = (status) => {
        if (status === "Quote provided") {
            return <p className='text-success'>{status}</p>
        } else if (status === "Expired") {
            return <p className='text-danger'>{status}</p>
        } else if (status === "Ordered") {
            return <p className='text-secondary'>{status}</p>
        } else {
            return <p className='text-info'>{status}</p>
        }
    }

    const debounced = (value) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            getQuotation(1, value);
        }, 500);

    }

    useEffect(() => {
        getQuotation(pagination.currentPage);
    }, []);

    return (
        <>
            <section className="admin_main full">
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Header as="h5">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                                        <div className="head_title">
                                            <h3 className="mb-0">Quotations</h3>
                                        </div>
                                        <InputGroup className="w-auto search-box">
                                            <Form.Control
                                                placeholder="Search"
                                                type='search'
                                                value={searchKey.key}
                                                onChange={(t) => {
                                                    setSearchKey((prevState) => ({
                                                        ...prevState,
                                                        key: t.target.value
                                                    }));
                                                    debounced(t.target.value);
                                                }} />
                                            {searchKey.key?.length > 0 ?
                                                <InputGroup.Text onClick={() => {
                                                    setSearchKey((prevState) => ({ ...prevState, key: "" }));
                                                    debounced("")
                                                }} type="button" className='button'>
                                                    <IconX size={24} stroke={2} />
                                                </InputGroup.Text>
                                                :
                                                <InputGroup.Text
                                                    id="basic-addon1"
                                                    type="button"
                                                    onClick={() => {
                                                        if (searchKey.key?.length <= 0) {
                                                            return;
                                                        }
                                                        getQuotation(1, searchKey.key);
                                                    }}
                                                    className='button'>
                                                    <IconSearch size={24} stroke={2} />
                                                </InputGroup.Text>
                                            }
                                        </InputGroup>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    {quotations?.length > 0 ?
                                        <div className='table-responsive'>
                                            <table className="client_table">
                                                <thead>
                                                    <tr className="d-none d-lg-table-row">
                                                        <th width="10%">Date</th>
                                                        <th width="10%">Service type</th>
                                                        <th width="4%">Currency</th>
                                                        <th width="9%">Recipient amount</th>
                                                        <th width="9%">Recipient currency</th>
                                                        <th width="5%">Status</th>
                                                        <th width="8%">Expire on</th>
                                                        <th width="5%">Rate</th>
                                                        <th width="5%">Sub total</th>
                                                        <th width="5%">Additional fee</th>
                                                        <th width="5%">Estimate total</th>
                                                        <th width="8%">Requested by</th>
                                                        <th width="10%">Requested email</th>
                                                        <th width="7%" className='text-end'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {quotations.map((q, index) => {
                                                        return (
                                                            <tr key={index} className="tr">
                                                                <td>
                                                                    <strong className="ht">Date : </strong>
                                                                    <small>{`${new Date(q.createdAt).toLocaleString()}-${new Date(q.createdAt).getMonth() + 1}-${new Date(q.createdAt).getFullYear()}`}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Service type : </strong>
                                                                    <small>{q.serviceType}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Currency : </strong>
                                                                    <small>{q?.currency?.toUpperCase()}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Recipient amount : </strong>
                                                                    <small>{parseFloat(q?.recipientAmount) > 0.01 ? parseFloat(q?.recipientAmount).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q?.recipientAmount)}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Recipient currency : </strong>
                                                                    <small>{q?.recipientCurrency.toUpperCase()}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Status : </strong>
                                                                    <small>{Status(q.status)}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Expire on : </strong>
                                                                    <small>{q.expireDate ?
                                                                        (
                                                                            <>
                                                                                {new Date(q.expireDate) > new Date() ?
                                                                                    <Countdown
                                                                                        autoStart={true}
                                                                                        date={new Date(q.expireDate)}
                                                                                    />
                                                                                    : "00:00:00:00"}
                                                                            </>
                                                                        )
                                                                        : "-"}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Rate : </strong>
                                                                    <small>{q.recipientCurrency === "ngn" ? q?.displayRate ? parseFloat(q.displayRate) > 0.01 ? parseFloat(q.displayRate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q.displayRate) : '-' : q?.rate ? parseFloat(q.rate) > 0.01 ? parseFloat(q.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q.rate) : '-'}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Sub total : </strong>
                                                                    <small>{q?.subTotal ? parseFloat(q.subTotal) > 0.01 ? parseFloat(q.subTotal).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q.subTotal) : '-'}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Additional fee : </strong>
                                                                    <small>{q?.additionalFee ? parseFloat(q.additionalFee) > 0.01 ? parseFloat(q.additionalFee).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q.additionalFee) : '-'}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Estimate total : </strong>
                                                                    <small>{q?.estimateTotal ? parseFloat(q.estimateTotal) > 0.01 ? parseFloat(q.estimateTotal).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q.estimateTotal) : '-'}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Requested by : </strong>
                                                                    <small>{q?.user?.userName ? q.user.userName : "not found"}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Requested email : </strong>
                                                                    <small>{q?.user?.email ? q.user.email : "not found"}</small>
                                                                </td>
                                                                <td>
                                                                    <strong className="ht">Action : </strong>
                                                                    <small className='text-end d-block'><Button
                                                                        disabled={q.status === "Ordered" || q.status === "Expired" ? true : false}
                                                                        className='button blue'
                                                                        onClick={() => {
                                                                            setQuotationId(q._id)
                                                                            setBaseCurrency(q.recipientCurrency);
                                                                            return setQuotingRequestShow(true)
                                                                        }}>
                                                                        Respond
                                                                    </Button></small>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                        : <p>Quotation not found</p>}
                                    <div className="d-flex justify-content-center mt-4">
                                        {pagination.previousPage || pagination.nextPage ?
                                            <Pagination>
                                                {pagination.previousPage ?
                                                    <Pagination.Item
                                                        onClick={() => { getQuotation(pagination.currentPage - 1) }}
                                                        key={pagination.currentPage - 1}>
                                                        {pagination.currentPage - 1}
                                                    </Pagination.Item>
                                                    : null}
                                                <Pagination.Item
                                                    active>
                                                    {pagination.currentPage}
                                                </Pagination.Item>
                                                {pagination.nextPage ?
                                                    <Pagination.Item
                                                        onClick={() => { getQuotation(pagination.currentPage + 1) }}
                                                        key={pagination.currentPage + 1}>
                                                        {pagination.currentPage + 1}
                                                    </Pagination.Item>
                                                    : null}
                                            </Pagination>
                                            : null}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Loader show={loader} />
            <AdminQuotingRequest
                show={QuotingRequestShow}
                quotationId={quotationId}
                currency={baseCurrency}
                getData={() => { getQuotation() }}
                onHide={() => {
                    setQuotingRequestShow(false);
                }} />
        </>
    )
}

export default Quotations